import { render, staticRenderFns } from "./rewardAirshipEdit.vue?vue&type=template&id=d96e4f40&scoped=true&"
import script from "./rewardAirshipEdit.vue?vue&type=script&lang=js&"
export * from "./rewardAirshipEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d96e4f40",
  null
  
)

export default component.exports